import { render, staticRenderFns } from "./SignUpCTAHeader.vue?vue&type=template&id=84785370&scoped=true&"
import script from "./SignUpCTAHeader.vue?vue&type=script&lang=js&"
export * from "./SignUpCTAHeader.vue?vue&type=script&lang=js&"
import style0 from "./SignUpCTAHeader.vue?vue&type=style&index=0&id=84785370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84785370",
  null
  
)

export default component.exports